var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"debug-panel"},[(_vm.debug)?[_vm._v(" Media: "+_vm._s(_vm.mediaType)),_c('br'),_vm._v("Mode: "+_vm._s(_vm.mode)),_c('br'),_vm._v("Multilabel: "+_vm._s(_vm.multilabel)),_c('br'),_vm._v("Remote: "+_vm._s(_vm.remote)+" "),_c('br')]:_vm._e(),_vm._v("Patient ID: "+_vm._s(_vm.patientID || 'n/a'))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }